export enum EProcessReportSearchParts {
    hostCodeArray= 'hostCodeArray',
    whenCreated= 'whenCreated',
    whenCreatedMin= 'whenCreatedMin',
    whenCreatedMax= 'whenCreatedMax',
    whenCreatedMinDescription= 'whenCreatedMinDescription',
    whenCreatedMaxDescription= 'whenCreatedMaxDescription',
    whenCancelled= 'whenCancelled',
    whenCancelledMin= 'whenCancelledMin',
    whenCancelledMax= 'whenCancelledMax',
    whenCancelledMinDescription= 'whenCancelledMinDescription',
    whenCancelledMaxDescription= 'whenCancelledMaxDescription',
    statusArray = 'statusArray',
    whenType = 'whenType',

}
